module.exports = __webpack_public_path__ + "static/media/left-arrow-back.8aa18ed3.svg";